import { QueryKey } from '@tanstack/react-query';
import { useMemo } from 'react';

import { AppID } from '@playq/octopus-common';
import { CheckFileRequest, CheckFileResponse, FileState } from '@playq/octopus2-files';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

import { UseCheckFileType } from '../filesService';

export const checkAssetKeys: QueryKey = ['asset', 'checkFile'];

export const useCheckAsset: UseCheckFileType = (
  { appID, check },
  options?: IUseQueryOptionsExtended<CheckFileResponse | undefined, GenericFailure | Error>
) => {
  const keys = useMemo(() => checkAssetKeys.concat(check), [check]);

  const isValid = useMemo(() => check !== undefined && appID !== undefined, [appID, check]);

  const res = useEitherQuery(
    keys,
    () => services2.appAssetsService.checkFile(appID as AppID, check as CheckFileRequest),
    {
      ...options,
      enabled: options?.enabled !== false && isValid,
    }
  );

  return {
    ...res,
    status: res.data?.state ?? FileState.NotFound,
    tags: keys,
  };
};
